// @ts-nocheck
import React, { useMemo } from 'react'
import Autocomplete from '@mui/material/Autocomplete';
import Chip from '@mui/material/Chip';
import { TextFieldRojo } from "../../../../App";
function AutocompleteListasDeCorreos(props) {
    const { alert, agregarListasSeleccionadas, listasNoSeleccionadas, listasSeleccionadas } = props
    const nombreDelArea = (option) => option['propietarioNombre'] ?? 'Predeterminado';

    const listasOrdenadas = useMemo(() => {
        if (!Array.isArray(listasNoSeleccionadas)) return [];
        return [...listasNoSeleccionadas].sort((a, b) => {
            if (a['propietario'] === 'Predeterminado' && b['propietario'] !== 'Predeterminado') {
                return 1;
            }
            if (a['propietario'] !== 'Predeterminado' && b['propietario'] === 'Predeterminado') {
                return -1;
            }
            if (a['propietario'] === b['propietario']) {
                return a['nombre'].localeCompare(b['nombre']);
            }
            return nombreDelArea(a).localeCompare(nombreDelArea(b));
        });
    }, [listasNoSeleccionadas]);

    return (
        <Autocomplete
            sx={{ width: '100%' }}
            multiple
            disablePortal
            id="combo-box-demo"
            noOptionsText="No se encontraron listas."
            value={listasSeleccionadas || []}
            options={listasOrdenadas}
            groupBy={(option) => nombreDelArea(option)}
            getOptionLabel={(option) =>
                option.codigo && option.tipo.descripcion !== 'ldap' && option.tipo.descripcion !== 'siu'
                    ? `${option.nombre} ${option.codigo}`
                    : option.nombre
            }
            onChange={(event, newValue) => agregarListasSeleccionadas(newValue)}
            renderTags={(value, getTagProps) =>
                value.map((option, index) => (
                    <Chip variant="outlined" label={option['nombre']} {...getTagProps({ index })} />
                ))
            }
            renderInput={(params) => (
                <TextFieldRojo
                    {...params}
                    error={
                        alert
                            ? alert.message ===
                            "No se ha introducido al menos una lista destinataria, este campo es obligatorio"
                            : false
                    }
                    label="Listas"
                />
            )}
        />

    );
}

export default AutocompleteListasDeCorreos;